import axios from "axios";

// Alumni sessions are separate from staff (admin/coordinator/teacher/etc.)
// sessions: alumni authenticate via mobile+OTP and get their own JWT, stored
// under its own localStorage key so it never collides with the staff
// 'user' key used by AuthContext.js / axiosConfig.js.

const ALUMNI_STORAGE_KEY = "alumni_session";

const alumniApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_API_URL}/api`,
});

alumniApi.interceptors.request.use((config) => {
  const stored = localStorage.getItem(ALUMNI_STORAGE_KEY);
  if (stored) {
    try {
      const session = JSON.parse(stored);
      if (session?.token) {
        config.headers.Authorization = `Bearer ${session.token}`;
      }
    } catch {
      // ignore malformed storage
    }
  }
  return config;
});

export const getAlumniSession = () => {
  const stored = localStorage.getItem(ALUMNI_STORAGE_KEY);
  if (!stored) return null;
  try {
    return JSON.parse(stored);
  } catch {
    return null;
  }
};

export const setAlumniSession = (session) => {
  localStorage.setItem(ALUMNI_STORAGE_KEY, JSON.stringify(session));
};

export const clearAlumniSession = () => {
  localStorage.removeItem(ALUMNI_STORAGE_KEY);
};

export { ALUMNI_STORAGE_KEY };
export default alumniApi;
